// ===================== CONFIGURATION =====================
const productVariantId = 50901714501913; // Product variant to add/remove
const cartThreshold = 35; // Minimum subtotal in dollars required to keep the product
const startDate = new Date('2024-06-11T00:00:00'); // Start of logic window
const endDate = new Date('2025-07-01T00:00:00'); // End of logic window
const isDevMode = false; // Toggle development logging
// =========================================================

let scriptStartTime; // For script execution timing (optional)

// Dev-only logger
function devLog(message, ...args) {
  if (isDevMode) {
    console.log(`[DEV] ${message}`, ...args);
  }
}

// Date range validator
function isWithinDateRange() {
  const now = new Date();
  devLog(`Checking current date: ${now} is within ${startDate} and ${endDate}`);
  return now >= startDate && now <= endDate;
}

// Fetch cart state
function fetchCartData() {
  devLog('Fetching cart data...');
  const start = performance.now();

  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const end = performance.now();
      devLog(`Cart data fetched in ${(end - start).toFixed(2)} ms`, cart);
      return cart;
    })
    .catch(error => {
      devLog('Error fetching cart:', error);
      return null;
    });
}

// Check if product is in the cart
function isProductInCart(cart, variantId) {
  if (!cart || !cart.items) return false;
  return cart.items.some(item => item.variant_id === variantId);
}

// Add product to cart
function addProductToCart(variantId) {
  devLog(`Adding product variant ${variantId} to cart...`);
  const start = performance.now();

  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);

  return fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(data => {
      const end = performance.now();
      devLog(`Product added in ${(end - start).toFixed(2)} ms`, data);
      return data;
    })
    .catch(error => {
      devLog('Error adding product:', error);
      return null;
    });
}

// Remove product from cart
function removeProductFromCart(variantId) {
  devLog(`Removing product variant ${variantId} from cart...`);
  const start = performance.now();

  const formData = new FormData();
  formData.append(`updates[${variantId}]`, 0);

  return fetch('/cart/update.js', {
    method: 'POST',
    body: formData
  })
    .then(response => response.json())
    .then(data => {
      const end = performance.now();
      devLog(`Product removed in ${(end - start).toFixed(2)} ms`, data);
      return data;
    })
    .catch(error => {
      devLog('Error removing product:', error);
      return null;
    });
}

// Main handler
function checkCartOnPageLoad() {
  devLog('Running cart validation logic...');

  if (!isWithinDateRange()) {
    devLog('Outside of active date range. No action taken.');
    return;
  }

  fetchCartData().then(cart => {
    if (!cart || !cart.items) {
      devLog('Cart data unavailable. Aborting operation.');
      return;
    }

    const subtotal = cart.items.filter(item => item.variant_id !== productVariantId).reduce((sum, item) => sum + item.line_price, 0) / 100; // Shopify subtotal is in cents
    const hasProduct = isProductInCart(cart, productVariantId);

    devLog(`Cart subtotal: $${subtotal.toFixed(2)}`);
    devLog(`Product present in cart: ${hasProduct}`);

    if (subtotal >= cartThreshold) {
      devLog('Cart subtotal meets or exceeds threshold.');

      if (!hasProduct) {
        addProductToCart(productVariantId).then(() => {
          devLog('Product successfully added to cart.');
        });
      } else {
        devLog('Product already present. No action needed.');
      }

    } else {
      devLog('Cart subtotal below threshold.');

      if (hasProduct) {
        removeProductFromCart(productVariantId).then(() => {
          devLog('Product successfully removed from cart.');
        });
      } else {
        devLog('Product not in cart. No action needed.');
      }
    }
  });
}

// Trigger on page load
window.addEventListener('load', checkCartOnPageLoad);
